import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { createSelector } from 'reselect';
export const getBrandSettings = state => state.resources.brandSettings.brandSettings;
export const getBrandSettingsFetchStatus = state => {
  return state.resources.brandSettings.requestStatus;
};
export const getBrandColors = createSelector([getBrandSettings], brandSettings => brandSettings && brandSettings.colors || []);
export const getBrandColorsFetchStatus = state => {
  return state.resources.brandSettings.colorsRequestStatus;
};
export const getBrandLogos = createSelector([getBrandSettings], brandSettings => brandSettings && brandSettings.logos || []);
export const getBusinessUnitId = (state, props) => {
  const {
    contentSchema
  } = state;
  // ensure buid 0 is returned
  if (contentSchema && !isNullOrUndefined(contentSchema.content.businessUnitId)) {
    return contentSchema.content.businessUnitId;
  }
  return props.businessUnitId || state.resources.brandSettings.businessUnitId;
};
export const getBrandKitId = state => {
  return state.resources.brandSettings.brandKitId;
};
export const getContentCategoryName = state => state.contentSchema && state.contentSchema.categoryName;
export const getBrandedLogoValue = state => {
  return state.resources.brandSettings.brandedLogo || {};
};